const defaultConstraints = {
  backtest: {
    'long-only': ['objective_function', 'gross_leverage_constraint', 'all_assets'],
    'long-short': ['objective_function', 'gross_leverage_constraint', 'net_leverage_constraint'],
  },
  basket: {
    'long-only': ['objective_function', 'gross_leverage_constraint', 'all_assets'],
    'long-short': [''],
  },
  strategy: {
    'long-only': ['objective_function', 'gross_leverage_constraint', 'all_assets'],
    'long-short': [''],
  },
};

export { defaultConstraints };
